"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('nav', {
    staticClass: "kiwi-navbar"
  }, [_c('div', {
    staticClass: "kiwi-navbar-brand"
  }, [_vm._v(" ImVerified Chat ")]), _c('div', {
    staticClass: "kiwi-navbar-center"
  }, [_vm.soulWallet ? _c('div', {
    staticClass: "soul-wallet-box",
    attrs: {
      "title": "Copiar dirección"
    },
    on: {
      "click": _vm.copyWallet
    }
  }, [_c('span', {
    staticClass: "soul-label"
  }, [_vm._v("Nickname Soul Card:")]), _c('span', {
    staticClass: "soul-address"
  }, [_vm._v(_vm._s(_vm.shortWallet))]), _c('i', {
    staticClass: "fa fa-copy soul-icon"
  })]) : _vm._e(), _vm.soulWallet ? _c('div', {
    staticClass: "reputation-box",
    attrs: {
      "title": "Reputación"
    }
  }, [_c('span', {
    staticClass: "reputation-label"
  }, [_vm._v("Reputación:")]), _c('span', {
    staticClass: "reputation-value"
  }, [_vm._v(_vm._s(_vm.reputationScore))]), _c('i', {
    staticClass: "fa fa-star reputation-icon"
  })]) : _vm._e(), _vm.soulWallet ? _c('div', {
    staticClass: "crypto-box",
    attrs: {
      "title": "Balance Qorum"
    }
  }, [_c('span', {
    staticClass: "crypto-value"
  }, [_vm._v("1.65")]), _c('span', {
    staticClass: "crypto-label"
  }, [_vm._v("QU")]), _c('i', {
    staticClass: "fa fa-diamond crypto-icon"
  })]) : _vm._e(), _c('button', {
    staticClass: "wallet-btn",
    attrs: {
      "title": "Abrir Wallet"
    },
    on: {
      "click": _vm.openWallet
    }
  }, [_c('i', {
    staticClass: "fa fa-wallet",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Abrir Wallet")])])]), _c('div', {
    staticClass: "kiwi-navbar-status"
  }, [_vm._v(" " + _vm._s(_vm.networkName) + " ")])]);
};
var staticRenderFns = exports.staticRenderFns = [];